// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import Immutable from 'immutable'

const {
  FETCH_TARGET_CONDITIONS_DONE,
  FETCH_TARGET_CONDITION_DONE,
  CREATE_TARGET_CONDITION_DONE,
  PATCH_TARGET_CONDITION_DONE
} = require('constants/ActionConstants').default

const TargetConditionStore = Marty.createStore({
  id: 'TargetConditionStore',

  getInitialState() {
    return Immutable.fromJS({
      targetsById: {}
    })
  },

  rehydrate(dehydratedState) {
    return this.state = Immutable.fromJS(dehydratedState)
  },

  handlers: {
    handleFetchTargetConditionsDone: FETCH_TARGET_CONDITIONS_DONE,
    handleTargetCreation: CREATE_TARGET_CONDITION_DONE,
    handlePatchTarget: PATCH_TARGET_CONDITION_DONE,
    handleFetchTargetConditionDone: FETCH_TARGET_CONDITION_DONE
  },

  setTarget(target) {
    return this.state = this.state.setIn(['targetsById', target.id], Immutable.fromJS(target))
  },

  handleFetchTargetConditionsDone(targets) {
    const targetsById = Immutable.fromJS(targets).reduce((targetsById, target) => targetsById.set(target.get('id'), target)
    , Immutable.Map())
    return this.state = this.state.mergeDeepIn(['targetsById'], targetsById)
  },

  handlePatchTarget(target) {
    return this.setTarget(target)
  },

  handleTargetCreation(target) {
    this.setTarget(target)
    return this.state = this.state.set('lastCreatedTargetId', target.id)
  },

  handleFetchTargetConditionDone(target) {
    return this.setTarget(target)
  },

  fetchTargets() {
    const id = 'fetchTargets'
    return this.fetch({
      id,
      locally() {
        if (this.hasAlreadyFetched(id)) { return this.state.get('targetsById') }
      },
      remotely() {
        return this.app.queries.TargetConditionQueries.fetchTargets()
      }
    })
  },

  getLastCreatedTargetId() {
    return this.state.get('lastCreatedTargetId', -1)
  },

  fetchTarget(targetId) {
    const id = `fetchTarget${ targetId }`
    return this.fetch({
      id,
      locally() {
        return this.state.get('targetsById').get(targetId)
      },
      remotely() {
        return this.app.queries.TargetConditionQueries.fetchTarget(targetId)
      }
    })
  }
})

export default TargetConditionStore



// WEBPACK FOOTER //
// ./src/scripts/stores/TargetConditionStore.js